import deleteService from '../deleteService';
import getService from '../getService';
import postService from '../postService';
import putService from '../putService';
import { ICreateSurveyQuestionRes, IGetSurveyQuestionsRes, IGetSurveyTemplates, IGetSurveyTemplatesRes } from '../../models/admin/Survey.model';


const CONFIG_API_URL =
 process.env.REACT_APP_API_BASE_URL || 'http://20.126.75.78/naptin/api/v1/';

const CREATEQUESTION = 'survey-questions'
const CREATESURVEYTEMPLATE = 'survey-templates'
const CREATESURVEY= 'surveys'

export default class SurveyService {
 static async postSurveyQuestion(data: ICreateSurveyQuestionRes) {
    const response = await postService.post(`${CONFIG_API_URL}${CREATEQUESTION}`, data);
    return response.data;
  }

  static async createSurveyTemplate(data:any) {
    const response = await postService.post(`${CONFIG_API_URL}${CREATESURVEYTEMPLATE}`, data);
    return response.data;
  }

  static async createSurvey(data: any){
    const response = await postService.post(`${CONFIG_API_URL}surveys-new`, data);
    return response.data;
  }

  static async createSurveyAnswer(uuid:string, data: any){
    const response = await postService.post(`${CONFIG_API_URL}survey-questions/${uuid}/answer-new`, data);
    return response.data;
  }

  static async getAllSurveys(){
    const response = await getService.get(`${CONFIG_API_URL}${CREATESURVEY}`);
    return response.data;
  }

  static async getSingleSurvey(uuid: string){
    const response = await getService.get(`${CONFIG_API_URL}surveys-new/${uuid}`);
    return response.data;
  }

  static async getSurveyQuestions() {
    const response = await getService.get(`${CONFIG_API_URL}${CREATEQUESTION}`);
    const data :IGetSurveyQuestionsRes = response.data
    return data;
  }

  static async getSurveyQuestion(uuid: string) {
    const response = await getService.get(`${CONFIG_API_URL}${CREATEQUESTION}/${uuid}`);
    const data :IGetSurveyQuestionsRes = response.data
    return data;
  }

  static async deleteSurveyQuestion(uuid: string) {
    const response = await deleteService.delete(`${CONFIG_API_URL}${CREATEQUESTION}/${uuid}`)
    const res :any = response.data;
    return res;
  }

  static async getSurveyTemplates() {
    const response = await getService.get(`${CONFIG_API_URL}${CREATESURVEYTEMPLATE}`);
    const data :IGetSurveyTemplatesRes = response.data;
    return data;
  }
}

